import React, { useMemo } from "react";
import { ActivityLogView, HttpLogView, PreWithCopy, ScreenLogView } from "./LogViews";
import CopyToClipboard from "../../../components/BuilderComponents/CopyToClipboard";

const parseLogData = (logData) => {
  try {
    if (typeof logData === "string") {
      return JSON.parse(logData);
    }
    return logData;
  } catch (e) {
    return { raw: logData };
  }
};

const LogHeader = ({ selectedLog }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      borderBottom: "1px solid #e5e7eb",
      paddingBottom: "10px",
      flexShrink: 0
    }}
  >
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <span
        style={{
          padding: "4px 8px",
          backgroundColor: "#374151",
          color: "white",
          borderRadius: "4px",
          fontSize: "12px",
          fontWeight: "bold",
          textTransform: "uppercase"
        }}
      >
        {selectedLog.type || "LOG"}
      </span>
      <span style={{ color: "#717a8bff", fontSize: "13px" }}>#{selectedLog.id}</span>
    </div>
    <div style={{ fontSize: "13px", color: "#111827", fontWeight: "500" }}>
      {selectedLog.user_email || "System/Anonymous"}
    </div>
  </div>
);

const MetadataFooter = ({ selectedLog, parsedData }) => (
  <div
    style={{
      marginTop: "10px",
      display: "grid",
      gap: "8px",
      fontSize: "12px",
      color: "#4b5563"
    }}
  >
    <MetadataRow label="App ID" value={selectedLog.app_id} showCopy />
    <MetadataRow label="User ID" value={selectedLog.user_id} showCopy />
    {parsedData.trace_id && <MetadataRow label="Trace ID" value={parsedData.trace_id} />}
  </div>
);

const MetadataRow = ({ label, value, showCopy = false }) => (
  <div style={{ display: "grid", gridTemplateColumns: "80px 1fr", gap: "10px", alignItems: "center" }}>
    <strong>{label}:</strong>
    <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
      <span style={{ fontFamily: "monospace" }}>{value}</span>
      {showCopy && <CopyToClipboard text={value} successMessage={label} />}
    </div>
  </div>
);

const SelectedMonitorLog = ({ selectedLog }) => {
  const parsedData = useMemo(() => parseLogData(selectedLog.log_data), [selectedLog.log_data]);

  const renderContent = () => {
    const type = (selectedLog.type || "").toLowerCase();

    switch (type) {
      case "http":
      case "api":
        return <HttpLogView parsedData={parsedData} />;
      case "screen":
      case "view":
        return <ScreenLogView parsedData={parsedData} />;
      case "form":
      case "activity":
      case "job":
        return <ActivityLogView parsedData={parsedData} type={type} />;
      default:
        return <PreWithCopy label="Log Data Payload" value={parsedData} />;
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "15px",
        height: "100%",
        overflow: "hidden"
      }}
    >
      <LogHeader selectedLog={selectedLog} />

      <div style={{ flex: 1, minHeight: 0, overflowY: "auto", paddingRight: "5px" }}>
        {renderContent()}

        <MetadataFooter
          selectedLog={selectedLog}
          parsedData={parsedData}
          // showRawMeta={showRawMeta}
          // onToggle={() => setShowRawMeta(!showRawMeta)}
        />
      </div>
    </div>
  );
};

export default SelectedMonitorLog;
